import React from "react";

const Loader = () => {
  return (
    <div id="loader-wrap">
     <div class="loader">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    </div>
  );
};

export default Loader;
